import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBagIcon } from 'lucide-react';
const NAMES = ['Marcos', 'Lucía', 'Federico', 'Ana', 'Gastón', 'Sofía', 'Pablo', 'Valentina', 'Facundo', 'Camila'];
const CITIES = ['Pergamino', 'Rosario', 'Córdoba', 'Mendoza', 'Rafaela', 'Tandil', 'Venado Tuerto', 'Río Cuarto', 'Santa Fe'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showPopup = () => {
      setData({
        name: NAMES[Math.floor(Math.random() * NAMES.length)],
        city: CITIES[Math.floor(Math.random() * CITIES.length)]
      });
      setIsVisible(true);
      setTimeout(() => setIsVisible(false), 4000);
    };
    const initial = setTimeout(showPopup, 5000);
    const interval = setInterval(() => {
      setTimeout(showPopup, Math.random() * 5000 + 10000);
    }, 15000);
    return () => {
      clearTimeout(initial);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-157">
      {isVisible && <motion.div initial={{
      x: -300,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -300,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 100,
      damping: 20
    }} className="fixed bottom-4 left-4 z-50 bg-white border-4 border-[#D4A843] rounded-xl shadow-2xl p-3 max-w-[280px] flex items-center gap-3" data-id="element-158">
          <div className="bg-[#F5F0E6] p-2 rounded-full flex-shrink-0" data-id="element-159">
            <ShoppingBagIcon className="w-5 h-5 text-[#D4A843]" data-id="element-160" />
          </div>
          <div data-id="element-161">
            <p className="text-xs font-black text-[#1F3D2B] uppercase leading-tight" data-id="element-162">
              {data.name} de {data.city}
            </p>
            <p className="text-[10px] text-[#2E5A3E] font-bold uppercase tracking-wide leading-tight mt-0.5" data-id="element-163">
              acaba de comprar el Kit de Gestión Agropecuaria
            </p>
            <p className="text-[9px] text-gray-500 font-bold mt-0.5 uppercase" data-id="element-164">
              Hace unos instantes
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}